import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import {
  RaglStockBlotterTable,
  type RaglStockBlotterTableViewContext,
} from '../../../../../../../../../../../../../features/clearing-ledger/delta/ragl-stock-blotter-table';
import { getPageHead } from '../../../../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset/account/$accountCode',
)({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `stock-record-takeoff-asset-${params.assetId}-account-${params.accountCode}`,
        label: params.accountCode,
        to: `/clearing/operations/stock-record/${params.assetId}/account/${params.accountCode}`,
      }),
    }) satisfies AggregateBreadcrumb,
  head: () => getPageHead('Account Stock Record Takeoff'),
  component: StockRecordTakeoff,
});

function StockRecordTakeoff() {
  const { accountCode, assetId } = Route.useParams();
  const viewContext = useMemo(
    () =>
      ({
        kind: 'asset',
        assetId,
        accountCode,
      }) as const satisfies RaglStockBlotterTableViewContext,
    [accountCode, assetId],
  );

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <RaglStockBlotterTable renderWhenEmpty="No Deltas" viewContext={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
